/* @flow */

import { rem } from 'polished';

import { tablet, portable } from '@e180/ui/lib/token/mediaQuery';
import { white, blueGrey } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  '@keyframes overlayFadeOut': {
    from: {
      opacity: 0.15,
    },
    to: {
      opacity: 0,
    },
  },
  root: {
    position: 'relative',
    display: 'flex',

    height: 156,
    padding: 12,

    backgroundColor: white,
    borderRadius: 'inherit',
    color: blueGrey,

    textDecoration: 'none',

    '&:visited': {
      color: blueGrey,
    },

    '&:focus': {
      outlineWidth: 0,
    },

    '&:hover': {
      color: blueGrey,
    },

    '&:active': {
      textDecoration: 'none',
    },
  },
  overlay: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,

    backgroundColor: ({ accentColor }: Object) => accentColor,
    opacity: 0.15,

    pointerEvents: 'none',

    animationName: 'overlayFadeOut',
    animationDuration: '4s',
    animationDelay: '2s',
    animationFillMode: 'forwards',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flex: 1,

    minWidth: 0,
    marginRight: '1em',
  },
  icon: {
    position: 'absolute',
    bottom: 3,
    right: 5,

    width: 'auto',
    maxWidth: 60,
    maxHeight: 60,

    [tablet]: {
      maxWidth: 80,
      maxHeight: 80,
    },

    [portable]: {
      maxWidth: 100,
    },
  },
  label: {
    position: 'absolute',
    bottom: -6,
    right: 5,

    color: ({ accentColor }: Object) => accentColor,

    fontSize: rem(13, baseFontSize),
    fontWeight: 600,

    [tablet]: {
      fontSize: rem(15, baseFontSize),
    },
  },
};
